import React, { useState, useRef, useEffect } from "react";
import { Download, ChevronDown } from "lucide-react";

// Export trigger. When the document has a unified cognitive output, it offers an
// English / Italiano report-language menu; otherwise a plain one-click export.
export const ExportControl = ({ onExport, hasUnified, variant = "icon", testid = "export-btn" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const triggerCls = variant === "pill"
    ? "flex items-center gap-2 text-xs tracking-[0.14em] uppercase text-muted-foreground hover:text-primary transition-colors border border-border hover:border-primary/40 rounded-full px-3 py-1.5"
    : "flex items-center justify-center w-9 h-9 rounded-full border border-border text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors";

  if (!hasUnified) {
    return (
      <button data-testid={testid} onClick={() => onExport("en")} aria-label="Export as PDF" className={triggerCls}>
        <Download strokeWidth={1.5} className="w-4 h-4" />
        {variant === "pill" && <span>Export</span>}
      </button>
    );
  }
  return (
    <div className="relative" ref={ref}>
      <button data-testid={testid} onClick={() => setOpen((o) => !o)} aria-label="Export report" className={triggerCls}>
        <Download strokeWidth={1.5} className="w-4 h-4" />
        {variant === "pill" && <span>Export</span>}
        {variant === "pill" && <ChevronDown strokeWidth={1.6} className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />}
      </button>
      {open && (
        <div data-testid="export-menu" className="absolute right-0 mt-2 w-44 bg-card border border-border rounded-xl shadow-2xl p-1.5 z-50">
          <p className="px-2.5 py-1.5 text-[10px] tracking-[0.16em] uppercase text-muted-foreground">Report language</p>
          <button data-testid="export-en" onClick={() => { setOpen(false); onExport("en"); }} className="w-full text-left text-sm px-2.5 py-2 rounded-lg text-foreground hover:bg-secondary transition-colors">English</button>
          <button data-testid="export-it" onClick={() => { setOpen(false); onExport("it"); }} className="w-full text-left text-sm px-2.5 py-2 rounded-lg text-foreground hover:bg-secondary transition-colors">Italiano</button>
        </div>
      )}
    </div>
  );
};
